<loading-screen [displayed]="state.loading && !state.error" [isUsedFromWidget]="isUsedFromWidget" [templateType]="skeletonType"></loading-screen>
@if (state.error && !state.loading) {
    <ng-content></ng-content>
}
